import clsx from 'clsx';
import { FunctionComponent, ReactNode } from 'react';

interface FullpageSectionProps {
  id: string;
  children: ReactNode;
  'aria-hidden'?: boolean;
}

const RevealSection: FunctionComponent<FullpageSectionProps> = (props) => {
  const { id, children, 'aria-hidden': ariaHidden = true } = props;

  return (
    <section className="future flex h-full" id={id} aria-hidden={ariaHidden}>
      <div
        className={clsx(
          'section px-2 sm:px-8 w-full h-full',
          'flex flex-col justify-center items-center m-auto',
          'opacity-0 transition-opacity duration-[0.1s] delay-[0.4s]',
        )}
      >
        {children}
      </div>
    </section>
  );
};

export default RevealSection;
